var resumeTypeOption = [{
  id: 1,
  text: '悬赏'
}, {
  id: 2,
  text: '非悬赏'
}];

var degreeOption = [{
  id: 3,
  text: '高中'
}, {
  id: 4,
  text: '专科'
}, {
  id: 5,
  text: '本科'
}, {
  id: 6,
  text: '硕士'
}, {
  id: 7,
  text: '博士'
}];

var sexOption = [{
  id: 1,
  text: '男'
},{
  id: 2,
  text: '女'
}];

var resumeRefreshOption = [{
  id: 1,
  text: '7天内'
},{
  id: 2,
  text: '1个月内'
},{
  id: 3,
  text: '3个月内'
},{
  id: 4,
  text: '6个月内'
},{
  id: 5,
  text: '超过6个月'
}];

var workYearOption = [{
  id: 0,
  text: '应届'
},{
  id: 1,
  text: '1年'
},{
  id: 2,
  text: '2年'
},{
  id: 3,
  text: '3年'
},{
  id: 4,
  text: '4年'
},{
  id: 5,
  text: '5年'
},{
  id: 6,
  text: '6年'
},{
  id: 7,
  text: '7年'
},{
  id: 8,
  text: '8年'
},{
  id: 9,
  text: '9年'
},{
  id: 10,
  text: '10+'
}];

var currentStateOption = [{
  id: 1,
  text: '正在找工作'
}, {
  id: 2,
  text: '考虑机会'
}, {
  id: 3,
  text: '暂不换工作'
}];

var industryOption = [{
  id: 1300,
  text: '酒店/旅游/餐饮/生活'
}, {
  id: 1400,
  text: '房地产/建筑装潢/物业'
}, {
  id: 1500,
  text: '金融'
}, {
  id: 1600,
  text: '物流/贸易/供应链'
}, {
  id: 1700,
  text: '能源/化工/矿产'
}, {
  id: 1800,
  text: '生物/制药/医疗'
}, {
  id: 1900,
  text: '制造/通讯/电子'
}, {
  id: 2000,
  text: '互联网/计算机'
}, {
  id: 2100,
  text: '广告/媒体/影视'
}, {
  id: 2200,
  text: '商业批发/零售'
}, {
  id: 2300,
  text: '泛行业/多元化/其他'
}, {
  id: 2400,
  text: '纺织/皮革/服装'
}, {
  id: 2500,
  text: '环保/新能源产业'
}, {
  id: 2600,
  text: '农业'
}, {
  id: 1200,
  text: '咨询/中介/检测专业服务'
}, {
  id: 1100,
  text: '留学/教育/培训'
}];

export {
  resumeTypeOption,
  degreeOption,
  sexOption,
  resumeRefreshOption,
  workYearOption,
  currentStateOption,
  industryOption
};
